<template>
  <div class="custom-tree" v-loading='loading'>
    <div class="selectFilterNum">已选择: <span style="color:#5088FF;font-size:13px;">{{selectFilterNum}}</span>个筛选条件</div>
    <custom-tree-group :change="onChange" :isRoot="true" @deletechildren="deleteChildren"></custom-tree-group>
  </div>
</template>

<script>
import isNil from 'lodash/isNil'
import isEqual from 'lodash/isEqual'
import customTreeGroup from './group'
import { highKeywordList, saveOrUpdateTemplate } from '../api/newClueApi'

export default {
  name: 'searchFilter',
  components: {
    customTreeGroup
  },
  data () {
    return {
      children: [],
      loading: false
    }
  },
  computed: {
    selectFilterNum () {
      const vos = this.$store.getters.getDefaultCondition.conditionVos
      let warpNum = vos.length
      let childNum = 0
      vos.forEach(e => {
        // if(e.childOption) && (childNum += e.childOption.conditionVos.length && warpNum--)
        if (e.childOption) {
          childNum += e.childOption.conditionVos.length
          warpNum--
        }
      })
      return warpNum + childNum
    }
  },
  mounted () {
    this.fetchConditionList()
  },
  methods: {

    onChange () {

    },
    deleteChildren (index) {
      const firstIndex = this.children.findIndex(item => item.data.id == index)
      this.children.splice(firstIndex, 1)
    },
    async fetchConditionList () { // 条件名称列表
      if (this.$store.getters.conditionList.length) return
      this.loading = true
      const { data } = await highKeywordList()
      this.loading = false
      const conditionList = data.map(item => {
        item.label = item.keyword
        item.conditions = item.children
        return item
      })
      this.$store.commit('setList', conditionList)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-tree {
  position: relative;
  padding-right: 24px;
  padding-top: 46px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  // color: #595959;
  color: #333333;
  
  .selectFilterNum {
    position: absolute;
    left: 25px;
    // bottom: 50px;
    bottom: 68px;
    font-size: 13px;
  }
}
</style>
